import { useState } from 'react'
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg'
import { ReactComponent as BlockedEyeIcon } from 'assets/icons/eye-blocked.svg'

const PasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false)
  const inputType = showPassword ? 'text' : 'password'
  return (
    <div className="relative">
      <input {...props} type={inputType} />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute h-full top-0 right-0 flex justify-center items-center pr-2"
      >
        {showPassword ? (
          <BlockedEyeIcon
            fill="#999"
            height="26"
            width="24"
            className="-mt-0.5"
          />
        ) : (
          <EyeIcon fill="#999" height="24" width="24" />
        )}
      </button>
    </div>
  )
}

export default PasswordInput
